module.exports = __webpack_public_path__ + "static/media/icon_star_f.158124dc.svg";